import { render, staticRenderFns } from "./prepaid.vue?vue&type=template&id=3196b763&scoped=true&"
import script from "./prepaid.vue?vue&type=script&lang=js&"
export * from "./prepaid.vue?vue&type=script&lang=js&"
import style0 from "./prepaid.vue?vue&type=style&index=0&id=3196b763&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3196b763",
  null
  
)

export default component.exports